var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { live } from 'lit/directives/live.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import styles from './checkbox.styles';
let PCheckbox = class PCheckbox extends LitElement {
    constructor() {
        super(...arguments);
        this.id = '';
        this.value = '';
        this.checked = false;
        this.toggleSlot = false;
        this.labelHidden = false;
    }
    static { this.styles = styles; }
    /**
     * Print aria-labelledby
     * @returns {string|null} Returns aria-labelledby or null
    */
    printAriaLabelledBy() {
        let ariaLabelBy = null;
        if (this.error) {
            ariaLabelBy = `error-${this.id}`;
        }
        if (this.help) {
            ariaLabelBy = `${ariaLabelBy ? ariaLabelBy + ' ' : ''}help-${this.id}`;
        }
        return ariaLabelBy;
    }
    /**
     * Handle change event
     * @returns {void}
     */
    handleChange() {
        this.checked = this.input.checked;
        if (this.toggleSlot) {
            if (this.checked) {
                this.toggleSlotElm.style.display = 'block';
            }
            else {
                this.toggleSlotElm.style.display = 'none';
            }
        }
        this.dispatchEvent(new CustomEvent('p-change', { bubbles: true, composed: true }));
    }
    /**
    * Render component
    * @returns {TemplateResult} Template
    */
    render() {
        const hasError = this.error || this.error === '' ? true : false;
        const classes = {
            ['has-error']: hasError,
            ['label-hidden']: this.labelHidden,
        };
        return html ` <div class="checkbox${classMap(classes)}"> <span class="checkbox-wrap"> <input type="checkbox" class="checkbox-input" id=${this.id} aria-labelledby=${ifDefined(this.printAriaLabelledBy())} value=${ifDefined(this.value)} aria-invalid=${ifDefined(this.error ? 'true' : null)} @change=${this.handleChange} ?required=${this.required} .checked=${live(this.checked)} /> <span class="checkbox-svg"> <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" width="16px" height="16px" viewBox="0 0 16 16"> <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/> </svg> </span> </span> <span class="checkbox-text"> <label class="label${this.labelHidden ? ' sr-only' : ''}" for=${this.id}> <slot></slot> ${this.label} ${this.required ? html `<span aria-hidden="true">*</span>` : ''}
          </label>
          ${this.help ? html `<div class="help" id="help-${this.id}">${this.help}</div>` : ''}
          ${this.error ? html `<div class="error" id="error-${this.id}">${this.error}</div>` : ''}
        </span>
      </div>
      <div class="toggle-slot">
        <slot name="toggle"></slot>
      </div>
    `;
    }
};
__decorate([
    property({ type: String })
], PCheckbox.prototype, "label", void 0);
__decorate([
    property({ type: String })
], PCheckbox.prototype, "help", void 0);
__decorate([
    property({ type: String, reflect: true })
], PCheckbox.prototype, "error", void 0);
__decorate([
    property({ type: String, attribute: 'input-id' })
], PCheckbox.prototype, "id", void 0);
__decorate([
    property()
], PCheckbox.prototype, "value", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PCheckbox.prototype, "required", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PCheckbox.prototype, "checked", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'toggle-slot' })
], PCheckbox.prototype, "toggleSlot", void 0);
__decorate([
    property({ type: Boolean, attribute: 'label-hidden' })
], PCheckbox.prototype, "labelHidden", void 0);
__decorate([
    query('.checkbox-input')
], PCheckbox.prototype, "input", void 0);
__decorate([
    query('.toggle-slot')
], PCheckbox.prototype, "toggleSlotElm", void 0);
PCheckbox = __decorate([
    customElement('p-checkbox')
    /**
    * PCheckbox component
    *
    * @class PCheckbox
    * @typedef {PCheckbox}
    * @extends {LitElement}
    */
], PCheckbox);
export { PCheckbox };
